import React, { useEffect } from 'react'
import { TextField, MenuItem, BaseTextFieldProps } from '@mui/material'
import { useWorkOrderState } from '../../../hooks'
import { WorkOrderState } from '../../../interfaces'

interface WarehouseDDLProps extends BaseTextFieldProps {
  onChange:
    | React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    | undefined
  value: string
  valueKey?: keyof WorkOrderState
}

export const WorkOrderStateDDL: React.FC<WarehouseDDLProps> = ({
  value,
  valueKey = 'workOrderStateId',
  ...otherProps
}) => {
  const {
    workOrderStatesState: { workOrderStates },
    getWorkOrderStates
  } = useWorkOrderState()

  useEffect(() => {
    if (workOrderStates?.length === 0) {
      getWorkOrderStates()
    }
  }, [])

  const arrTypePositions =
    workOrderStates !== undefined
      ? workOrderStates.map((option: WorkOrderState) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option.state}
          </MenuItem>
        ))
      : []

  return (
    <TextField {...otherProps} id={valueKey} select value={value}>
      <MenuItem key={-1} value={-1}>
        {'Seleccionar estado...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
